module.exports = __webpack_public_path__ + "d646dc0752b91bb81f1a0427a8e6eea3.fbx";